/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'remove': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.467 9.5c.294 0 .533.224.533.5a.51.51 0 01-.438.492l-.095.008H2.533C2.24 10.5 2 10.276 2 10a.51.51 0 01.437-.492l.096-.008h14.934z" _fill="#1D3861"/>'
  }
})
